import { RootState } from '../../rootReducer';
import { BlockedByFeature } from '../../../featureToggles/features/utils';
import { IAddEnterpriseSeatsState } from './interfaces';
import { IAddEnterpriseSeatsStateTrialsOfTiers } from '.';

const getAddEnterpriseSeatsState = (state: Pick<RootState, 'accounts'>): IAddEnterpriseSeatsState | undefined => {
  const addEnterpriseSeatsState: IAddEnterpriseSeatsStateTrialsOfTiers = state.accounts.addEnterpriseSeats;
  if (addEnterpriseSeatsState === BlockedByFeature) {
    return;
  }
  return addEnterpriseSeatsState;
};

const selectLoadingAddEnterpriseSeats = (state: Pick<RootState, 'accounts'>): boolean => getAddEnterpriseSeatsState(state)?.loading ?? false;

export const selectors = {
  selectLoadingAddEnterpriseSeats
};
